import { useLocation, useSearchParams, type Location } from 'react-router';

import { useIsAfterDate } from '@/hooks/useIsAfterDate.ts';
import type { NoDate } from '@/services/new-utils.ts';

export type MakeHasEndedArgs = { location: Location };

export const makeHasEnded = (date: NoDate | ((args: MakeHasEndedArgs) => NoDate)) => {
  const isNotProd = import.meta.env.VITE_STAGE !== 'release';

  const useHasEnded = (): boolean => {
    const location = useLocation();
    const [params] = useSearchParams();
    const isAfter = useIsAfterDate(typeof date === 'function' ? date({ location }) : date);

    if (isNotProd) {
      if (params.has('ended')) {
        return params.get('ended') !== 'false';
      }
    }

    return isAfter;
  };

  return useHasEnded;
};
